import { useEffect, useState } from 'react';
import { fetchData } from './Helpers'; 

export default function Fields() {
  const [ddIndex, setDdIndex] = useState(0);
  const fields = {
    "/coverages":"coverages",
    "/actuals/kpis":"actualsKpis",
    "/actuals/periodic-measures":"actualsPeriodicMeasures",
    "/summaries/kpis":"summariesKpis",
    "/summaries/non-periodic-measures":"summariesNonPeriodicMeasures",
    "/summaries/periodic-measures":"summariesPeriodicMeasures",
    "/summaries/recommendations":"summariesRecommendations",
    "/summaries/kpi-historical-snapshots":"summariesKpiHistoricalSnapshots",
    "/summaries/periodic-measures-historical-snapshots":"summariesPeriodicMeasuresHistoricalSnapshots",
    "/summaries/non-periodic-measures-historical-snapshots":"summariesNonPeriodicMeasuresHistoricalSnapshots",
    "/summaries/recommendations-historical-snapshots":"summariesRecommendationsHistoricalSnapshots",
    "/summaries/analytics/companies":"summariesAnalyticsCompanies"
  }
  const [endpointsData, setEndpointsData] = useState([]);
  const [descriptionData, setDescriptionData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData("Est_Endpoints_Fields").then(res => {
      setEndpointsData(res);
      setLoading(false);
    });
    fetchData("Est_Field_Descriptions").then(res => {
      setDescriptionData(res);
    });
  }, []);
  
  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>Endpoints-Fields</h4>
      <ef-layout className="est-fields-package-layout">
        {Object.entries(fields).map(([key, value], index) => (
          <ef-layout>
            <ef-layout className="est-fields-inner-layout" onClick={() => setDdIndex(ddIndex === index+1 ? 0 : index+1)} key={key}>
              <ef-panel spacing>
                {ddIndex !== index+1 && <ef-icon icon="right"></ef-icon>}
                {ddIndex === index+1 && <ef-icon icon="down"></ef-icon>}
                <span>{key}</span>
              </ef-panel>
            </ef-layout>
            {ddIndex === index+1 && <ef-layout className="est-endpoint-layout">
              <table>
                <thead>
                  <tr>
                    <th>Data Field</th>
                    <th>Field Description</th>
                  </tr>
                </thead>
                <tbody>
                  {endpointsData.filter(item => item[value] !== "").map((item, idx) => (
                    <tr key={idx}>
                      <td>{item[value]}</td>
                      {descriptionData.filter(desc => desc.dataField === item[value]).length === 0 && <td>No description found</td>}
                      {descriptionData.filter(desc => desc.dataField === item[value]).length > 0 && <td>{descriptionData.filter(desc => desc.dataField === item[value])[0].fieldDescription}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </ef-layout>}
          </ef-layout>
        ))}
      </ef-layout>
    </div>
  );
}